import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { LoadListServices } from 'src/app/core/services/load-list.services';
import { BudgetDetails } from 'src/app/shared/models/detalle-presupuesto';
import { BudgetSignatures } from 'src/app/shared/models/firmas-presupuesto';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';
import { Select } from 'src/app/shared/models/select';

@Component({
  selector: 'app-datos-generales-presupuesto',
  templateUrl: './datos-generales-presupuesto.component.html',
  styleUrls: ['./datos-generales-presupuesto.component.css'],
  providers: [DatePipe]
})
export class DatosGeneralesPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  listTitulosObras: Select[] = [];
  listCapturaPrecios: Select[] = [];
  listOpcionesIva: Select[] = [];
  listEmpresas: Select[] = [];
  listReemplazarPrecios: Select[] = [];
  minDate: Date;
  fechaSeleccionada: Date;
  cargado = false;

  datosGeneralesPresupuestoForm: FormGroup;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  editar: boolean = true;
  tempAplicarIva: number = 0;
  infoPresupuesto: BudgetDetails;
  classFlag: boolean = false;
  tempNombrePresupuesto: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public pBudgetId: number,
    public dialogDatosGeneralesPresupuestoRef: MatDialogRef<DatosGeneralesPresupuestoComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<Date>,
    private cachePartidasService: CachePartidasService,
    private loadListServices: LoadListServices
  ) {
    this.dateAdapter.setLocale(Constanst.LOCALE_VE);
  }

  ngOnInit() {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.infoPresupuesto = this.helperClassService.getData();
    this.datosGeneralesPresupuestoForm = new FormGroup({
      nombrePresupuesto: new FormControl({ value: '', disabled: true }),
      nombreEmpresa: new FormControl({ value: '', disabled: true }),
      tituloObra: new FormControl({ value: '', disabled: true }),
      capturaPrecios: new FormControl({ value: '', disabled: true }),
      descripcionPresupuesto: new FormControl({ value: '', disabled: true }),
      ubicacionCondicionesValidez: new FormControl({ value: '', disabled: true }),
      contratante: new FormControl({ value: '', disabled: true }),
      numContrato: new FormControl({ value: '', disabled: true }),
      fechaPresupuesto: new FormControl({ value: '', disabled: true }),
      aplicarIva: new FormControl({ value: '', disabled: true }),
      reemplazarPrecios: new FormControl({ value: '', disabled: true }),
      nombreFirmaUno: new FormControl({ value: '', disabled: false }),
      descripcionFirmaUno: new FormControl({ value: '', disabled: true }),
      civFirmaUno: new FormControl({ value: '', disabled: true }),
      nombreFirmaDos: new FormControl({ value: '', disabled: true }),
      descripcionFirmaDos: new FormControl({ value: '', disabled: true }),
      civFirmaDos: new FormControl({ value: '', disabled: true }),
      nombreFirmaTres: new FormControl({ value: '', disabled: true }),
      descripcionFirmaTres: new FormControl({ value: '', disabled: false }),
      civFirmaTres: new FormControl({ value: '', disabled: true }),
      nombreFirmaCuatro: new FormControl({ value: '', disabled: true }),
      descripcionFirmaCuatro: new FormControl({ value: '', disabled: true }),
      civFirmaCuatro: new FormControl({ value: '', disabled: true })
    });

    this.listEmpresas = this.loadListServices.getAllCompanyBudget();
    this.listTitulosObras = this.loadListServices.getWorksTitlesBudget();
    this.listCapturaPrecios = this.loadListServices.getPriceCaptureBudget();
    this.listOpcionesIva = this.loadListServices.getIvaOptionsBudget();
    this.listReemplazarPrecios = this.loadListServices.getReplacePricesBudget();
    this.getBudgetData();
    this.cargado = true;
  }

  getBudgetData() {
    this.route = '/getGeneralDetailBudget';
    this.method = 'POST';
    let data = {
      idBudget: this.pBudgetId
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          this.tempAplicarIva = response.data.applyPrice;
          this.tempNombrePresupuesto = response.data.budgetName;
          let fechaPresupuestoString = this.datePipe.transform(response.data.budgetDate, 'yyyy/MM/dd');
          this.datosGeneralesPresupuestoForm = new FormGroup({
            nombrePresupuesto: new FormControl({ value: response.data.budgetName, disabled: true }, [Validators.required, Validators.minLength(4), Validators.maxLength(250)]),
            nombreEmpresa: new FormControl({ value: response.data.idCompany, disabled: true }, [Validators.required]),
            tituloObra: new FormControl({ value: response.data.workTittle, disabled: true }),
            capturaPrecios: new FormControl({ value: response.data.catchPrice, disabled: true }),
            descripcionPresupuesto: new FormControl({ value: response.data.descriptionName, disabled: true }, [Validators.minLength(10), Validators.maxLength(250)]),
            ubicacionCondicionesValidez: new FormControl({ value: response.data.location, disabled: true }, [Validators.minLength(4), Validators.maxLength(50)]),
            contratante: new FormControl({ value: response.data.contractor, disabled: true }, [Validators.required, Validators.minLength(4), Validators.maxLength(50)]),
            numContrato: new FormControl({ value: response.data.contractorNumber, disabled: true }, [Validators.minLength(4), Validators.maxLength(14)]),
            fechaPresupuesto: new FormControl({ value: new Date(fechaPresupuestoString!), disabled: true }),
            aplicarIva: new FormControl({ value: String(response.data.applyPrice), disabled: true }),
            reemplazarPrecios: new FormControl({ value: String(response.data.replacePrice), disabled: true }),
            nombreFirmaUno: new FormControl({ value: response.data.firstSigneName, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            descripcionFirmaUno: new FormControl({ value: response.data.firstSigneDescription, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            civFirmaUno: new FormControl({ value: response.data.firstSigneDocument, disabled: true }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)]),
            nombreFirmaDos: new FormControl({ value: response.data.secondSigneName, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            descripcionFirmaDos: new FormControl({ value: response.data.secondSigneDescription, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            civFirmaDos: new FormControl({ value: response.data.secondSigneDocument, disabled: true }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)]),
            nombreFirmaTres: new FormControl({ value: response.data.thirdSigneName, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            descripcionFirmaTres: new FormControl({ value: response.data.thirdSigneDescription, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            civFirmaTres: new FormControl({ value: response.data.thirdSigneDocument, disabled: true }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)]),
            nombreFirmaCuatro: new FormControl({ value: response.data.fourSigneName, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            descripcionFirmaCuatro: new FormControl({ value: response.data.fourSigneDescription, disabled: true }, [Validators.minLength(4), Validators.maxLength(20)]),
            civFirmaCuatro: new FormControl({ value: response.data.fourSigneDocument, disabled: true }, [Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(5), Validators.maxLength(10)])
          });
          this.minDate = new Date(fechaPresupuestoString!);
          this.apiCallService.hideSpinner();
        } else {
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
      });
  }

  onSubmit(): void {
    if (this.datosGeneralesPresupuestoForm.invalid) {
      return;
    } else {
      return this.modificarDatosPresupuesto();
    }
  }

  modificarDatosPresupuesto() {
    const dialogUpdateBudget = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_UPDATE_BUDGET, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialogUpdateBudget.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        let newAplicarIva = Number(this.datosGeneralesPresupuestoForm.controls['aplicarIva'].value);
        let newNombrePresupuesto = this.datosGeneralesPresupuestoForm.controls['nombrePresupuesto'].value;
        this.route = '/updateGeneralInfoBudget';
        this.method = 'POST';

        let nombreFirmaUno = this.datosGeneralesPresupuestoForm.controls['nombreFirmaUno'].value;
        let descripcionFirmaUno = this.datosGeneralesPresupuestoForm.controls['descripcionFirmaUno'].value;
        let civFirmaUno = this.datosGeneralesPresupuestoForm.controls['civFirmaUno'].value;
        let nombreFirmaDos = this.datosGeneralesPresupuestoForm.controls['nombreFirmaDos'].value;
        let descripcionFirmaDos = this.datosGeneralesPresupuestoForm.controls['descripcionFirmaDos'].value;
        let civFirmaDos = this.datosGeneralesPresupuestoForm.controls['civFirmaDos'].value;
        let nombreFirmaTres = this.datosGeneralesPresupuestoForm.controls['nombreFirmaTres'].value;
        let descripcionFirmaTres = this.datosGeneralesPresupuestoForm.controls['descripcionFirmaTres'].value;
        let civFirmaTres = this.datosGeneralesPresupuestoForm.controls['civFirmaTres'].value;
        let nombreFirmaCuatro = this.datosGeneralesPresupuestoForm.controls['nombreFirmaCuatro'].value;
        let descripcionFirmaCuatro = this.datosGeneralesPresupuestoForm.controls['descripcionFirmaCuatro'].value;
        let civFirmaCuatro = this.datosGeneralesPresupuestoForm.controls['civFirmaCuatro'].value;

        let data = {
          budgetUserEntity: {
            idBudget: this.pBudgetId,
            companyBudgetEntity: {
              idCompany: this.datosGeneralesPresupuestoForm.controls['nombreEmpresa'].value,
            },
            budgetName: this.datosGeneralesPresupuestoForm.controls['nombrePresupuesto'].value,
            workTittle: this.datosGeneralesPresupuestoForm.controls['tituloObra'].value,
            catchPrice: this.datosGeneralesPresupuestoForm.controls['capturaPrecios'].value,
            description: this.datosGeneralesPresupuestoForm.controls['descripcionPresupuesto'].value,
            location: this.datosGeneralesPresupuestoForm.controls['ubicacionCondicionesValidez'].value,
            contractor: this.datosGeneralesPresupuestoForm.controls['contratante'].value,
            contractNumber: this.datosGeneralesPresupuestoForm.controls['numContrato'].value,
            applyIva: newAplicarIva,
            firstSignedName: nombreFirmaUno,
            firstSignedDescription: descripcionFirmaUno,
            firstSignedDocument: civFirmaUno,
            secondSignedName: nombreFirmaDos,
            secondSignedDescription: descripcionFirmaDos,
            secondSignedDocument: civFirmaDos,
            thirdSignedName: nombreFirmaTres,
            thirdSignedDescription: descripcionFirmaTres,
            thirdSignedDocument: civFirmaTres,
            fourthSignedName: nombreFirmaCuatro,
            fourthSignedDescription: descripcionFirmaCuatro,
            fourthSignedDocument: civFirmaCuatro,
            budgetDate: this.datosGeneralesPresupuestoForm.controls['fechaPresupuesto'].value,
            replacePrices: Number(this.datosGeneralesPresupuestoForm.controls['reemplazarPrecios'].value)
          }
        }

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(response => {

            if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {

              let listFirmasPresupuesto: BudgetSignatures[] = [];
              if (nombreFirmaUno != null && nombreFirmaUno.trim() != '' &&
                descripcionFirmaUno != null && descripcionFirmaUno.trim() != '' &&
                civFirmaUno != null && civFirmaUno.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = nombreFirmaUno;
                signature.description = descripcionFirmaUno;
                signature.ci = civFirmaUno;
                listFirmasPresupuesto.push(signature);
              }
              if (nombreFirmaDos != null && nombreFirmaDos.trim() != '' &&
                descripcionFirmaDos != null && descripcionFirmaDos.trim() != '' &&
                civFirmaDos != null && civFirmaDos.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = nombreFirmaDos;
                signature.description = descripcionFirmaDos;
                signature.ci = civFirmaDos;
                listFirmasPresupuesto.push(signature);
              }
              if (nombreFirmaTres != null && nombreFirmaTres.trim() != '' &&
                descripcionFirmaTres != null && descripcionFirmaTres.trim() != '' &&
                civFirmaTres != null && civFirmaTres.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = nombreFirmaTres;
                signature.description = descripcionFirmaTres;
                signature.ci = civFirmaTres;
                listFirmasPresupuesto.push(signature);
              }
              if (nombreFirmaCuatro != null && nombreFirmaCuatro.trim() != '' &&
                descripcionFirmaCuatro != null && descripcionFirmaCuatro.trim() != '' &&
                civFirmaCuatro != null && civFirmaCuatro.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = nombreFirmaCuatro;
                signature.description = descripcionFirmaCuatro;
                signature.ci = civFirmaCuatro;
                listFirmasPresupuesto.push(signature);
              }

              if (newNombrePresupuesto.trim() != this.tempNombrePresupuesto.trim()) {
                this.infoPresupuesto.budgetName = newNombrePresupuesto.trim();
                this.helperClassService.notifierNewChangeBudget.emit('budgetName');
              }

              this.infoPresupuesto.signatures = listFirmasPresupuesto;
              this.helperClassService.setData(this.infoPresupuesto);

              if (newAplicarIva != this.tempAplicarIva) {

                this.route = '/getAllBudgetLineItemByBudget';
                this.method = 'POST';
                let data = {
                  idBudget: this.pBudgetId
                };

                this.apiCallService.call$(data, this.route, this.method, true, '', true)
                  .pipe(takeUntil(this.destroy$)).subscribe(responseItems => {

                    if (responseItems.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                      for (let i = 0; i < responseItems.data.length; i++) {
                        let partida: BudgetItem = {
                          position: (i + 1),
                          chapterReference: (responseItems.data[i].referenceChapter != null ? responseItems.data[i].referenceChapter : ''),
                          reference: responseItems.data[i].referenceBudgetLineItem,
                          code: responseItems.data[i].codeBudgetLineItem,
                          description: responseItems.data[i].descriptionBudgetLineItem,
                          unit: responseItems.data[i].unitName,
                          quantity: responseItems.data[i].lineItemQuantity,
                          unitPrice: responseItems.data[i].calculatedUnitPrice,
                          assumedPrice: responseItems.data[i].assumedPrice,
                          total: (responseItems.data[i].calculatedUnitPrice * responseItems.data[i].lineItemQuantity),
                          performance: responseItems.data[i].performance,
                          idLineItem: responseItems.data[i].idLineItem,
                          lineItemGrouping: responseItems.data[i].groupingDescription,
                          idBudgetLineItem: responseItems.data[i].idBudgetLineItem,
                          idChapterReference: (responseItems.data[i].idChapter != null ? responseItems.data[i].idChapter : null),
                          descriptionChapter: (responseItems.data[i].descriptionChapter != null ? responseItems.data[i].descriptionChapter : ''),
                          benefit: responseItems.data[i].benefit,
                          administrativeExpense: responseItems.data[i].administrativeExpense,
                          unexpectedUtility: responseItems.data[i].unexpectedUtility,
                          financing: responseItems.data[i].financing,
                          iva: responseItems.data[i].iva,
                          otherTax: responseItems.data[i].otherTax,
                          idLineItemUser: responseItems.data[i].idLineItemUser
                        }
                        this.cachePartidasService.modify(partida.idLineItem.toString(), partida);
                      }
                      this.apiCallService.hideSpinner();
                      const dialogUpdate = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BUDGET_UPDATED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
                      dialogUpdate.afterClosed().subscribe((result: string) => {
                        let tipoIva: string = '';
                        if (newAplicarIva == 1) { tipoIva = Constanst.APLICAR_IVA_PRESUPUESTO };
                        if (newAplicarIva == 2) { tipoIva = Constanst.APLICAR_IVA_APU };
                        if (newAplicarIva == 3) { tipoIva = Constanst.APLICAR_IVA_NINGUNO };
                        this.helperClassService.notifierNewChangeBudget.emit(tipoIva.trim());
                      });

                    } else {
                      this.apiCallService.hideSpinner();
                      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                    }
                  });

              } else {
                this.apiCallService.hideSpinner();
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BUDGET_UPDATED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
              }

            } else {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BUDGET_UPDATED_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
            }
            this.closeDialogDatosGeneralesPresupuesto();
          },
            error => {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            });
      } else {
        dialogUpdateBudget.close(false);
      }
    });
  }

  habilitarCampos() {
    this.datosGeneralesPresupuestoForm.get('nombrePresupuesto')?.enable();
    this.datosGeneralesPresupuestoForm.get('tituloObra')?.enable();
    this.datosGeneralesPresupuestoForm.get('capturaPrecios')?.enable();
    this.datosGeneralesPresupuestoForm.get('descripcionPresupuesto')?.enable();
    this.datosGeneralesPresupuestoForm.get('ubicacionCondicionesValidez')?.enable();
    this.datosGeneralesPresupuestoForm.get('contratante')?.enable();
    this.datosGeneralesPresupuestoForm.get('numContrato')?.enable();
    this.datosGeneralesPresupuestoForm.get('fechaPresupuesto')?.enable();
    this.datosGeneralesPresupuestoForm.get('aplicarIva')?.enable();
    this.datosGeneralesPresupuestoForm.get('reemplazarPrecios')?.enable();
    this.datosGeneralesPresupuestoForm.get('nombreFirmaUno')?.enable();
    this.datosGeneralesPresupuestoForm.get('descripcionFirmaUno')?.enable();
    this.datosGeneralesPresupuestoForm.get('civFirmaUno')?.enable();
    this.datosGeneralesPresupuestoForm.get('nombreFirmaDos')?.enable();
    this.datosGeneralesPresupuestoForm.get('descripcionFirmaDos')?.enable();
    this.datosGeneralesPresupuestoForm.get('civFirmaDos')?.enable();
    this.datosGeneralesPresupuestoForm.get('nombreFirmaTres')?.enable();
    this.datosGeneralesPresupuestoForm.get('descripcionFirmaTres')?.enable();
    this.datosGeneralesPresupuestoForm.get('civFirmaTres')?.enable();
    this.datosGeneralesPresupuestoForm.get('nombreFirmaCuatro')?.enable();
    this.datosGeneralesPresupuestoForm.get('descripcionFirmaCuatro')?.enable();
    this.datosGeneralesPresupuestoForm.get('civFirmaCuatro')?.enable();
    this.editar = false;
  }

  closeDialogDatosGeneralesPresupuesto() {
    this.dialogDatosGeneralesPresupuestoRef.close();
  }

}
